'use client';

import type { ReactNode } from 'react';
import { useStore } from 'zustand';

import { authStore } from '@/store/auth.store';

export function HideWhenLoggedIn({ children }: { children: ReactNode }) {
  const isLoggedIn = useStore(authStore, (state) => state.computed.isLoggedIn);

  if (isLoggedIn) {
    return null;
  }

  return <>{children}</>;
}
